module.exports = __webpack_public_path__ + "static/media/final_sommartavling.7ebd910d.jpg";